export default {
    indexUserPhotos:    { method: 'get',    url: 'user_photos' },
    createUserPhoto:    { method: 'post', url: 'user_photos'},
    destroyUserPhoto:   { method: 'delete', url: 'user_photos/{id}'},
}